
import { Options } from "vue-class-component";
import ComponentConfigMixins from "../ComponentConfigMixins";

@Options({
    name: "flowable-common-form-components-image-upload-config",
})
export default class ImageUploadConfig extends ComponentConfigMixins {}
